import styled from 'styled-components';

export const ContainerLogin = styled.div`
  min-height: 100vh;
  margin: 0px auto 0px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  #loginForm {
    background: #fff;
    padding: 40px;
    border-radius: 5px;
    box-shadow: 0px 0px 12px #ccc;

    input {
      width: 400px;
      border-radius: 0px;
    }

    .logo {
      text-align: center;

      img {
        margin: 0 auto;
        width: 150px;
        margin-bottom: 20px;
      }
    }

    #btnLogin {
      background: ##2c3e50;
      color: rgb(255, 255, 255);
      border: none;
      width: 100%;
      margin-top: 40px;
      font-size: 19px;
      padding: 5px;
      border-radius: 5px;
      font-weight: bold;
    }
  }

  @media (max-width: 600px) {
    #loginForm {
      width: 100%;
      padding: 20px;

      input {
        width: 100%;
      }
    }
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #2c3e50;
    text-align: center;
  }
`;
